// extracted by mini-css-extract-plugin
export default {"input_div":"SetupSlipGaji_input_div__wY6Pf","title":"SetupSlipGaji_title__otOib","periode_input":"SetupSlipGaji_periode_input__1VjVw"};